let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3X8iz")).then(() => parcelRequire('WCqcH'));